import { PersonType } from '../types'

export type RecipientGroup = {
  label: string | null
  people: PersonType[]
}

const trimmedApartment = (person: PersonType): string => (person.apartmentNumber ?? '').trim()

export const filterRecipients = (list: PersonType[], query: string): PersonType[] => {
  const needle = query.toLowerCase().trim()
  if (!needle) return list
  return list.filter((person) => {
    const name = person.name.toLowerCase()
    const apartment = trimmedApartment(person).toLowerCase()
    return name.includes(needle) || apartment.includes(needle)
  })
}

// Group by trimmed ApartmentNumber (case-insensitive key, first original label).
// Empty/missing values trail in an unlabelled section. If nobody has a value,
// a single unlabelled group is returned so the list looks like today's flat UI.
export const groupRecipients = (list: PersonType[]): RecipientGroup[] => {
  const labelled = new Map<string, { label: string; people: PersonType[] }>()
  const ungrouped: PersonType[] = []

  list.forEach((person) => {
    const raw = trimmedApartment(person)
    if (!raw) {
      ungrouped.push(person)
      return
    }
    const key = raw.toLowerCase()
    const existing = labelled.get(key)
    if (existing) {
      existing.people.push(person)
      return
    }
    labelled.set(key, { label: raw, people: [person] })
  })

  const groups: RecipientGroup[] = Array.from(labelled.values())
    .sort((a, b) =>
      a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' })
    )
    .map((group) => ({ label: group.label, people: group.people }))

  if (ungrouped.length) {
    groups.push({ label: null, people: ungrouped })
  }

  return groups
}
